export const ProjectStatusVals = {
  New: 1,
  InWork: 2,
  Completed: 3
}

export function getProjectStatusBadge(statusId?: number) {
    switch(statusId){
      case ProjectStatusVals.New:
        return `badge badge-secondary`;
      case ProjectStatusVals.InWork:
        return `badge badge-info`;
      case ProjectStatusVals.Completed:
        return `badge badge-success`;
      default: return ``;
    }
}